<template>
  <div class="heads">
    <div class="head-bx">
      <div class="top">
        <div class="left">
          <p>算法</p>
          <el-select v-model="value" placeholder="请选择算法">
            <el-option
              v-for="item in eloptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="right">
          <div class="btn btns"></div>
          <div class="btn" @click="previousclick">&lt; previous</div>
          <div class="btn" @click="nextclick">&gt; next</div>
        </div>
      </div>

      <div class="pczhn">
         <el-carousel ref="carousel" :autoplay="carouselOptions.autoplay" trigger="click">
      <el-carousel-item v-for="item in imgarr" :key="item">
       <img :src="item" alt="">
      </el-carousel-item>
    </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    carouselOptions: {
      autoplay: false, // 添加此行以关闭自动播放
    },
      imgarr:[  require('@/assets/pred/0pred.png'),
  require('@/assets/pred/1pred.png'),
  require('@/assets/pred/2pred.png'),
  require('@/assets/pred/3pred.png'),
  require('@/assets/pred/4pred.png'),
  require('@/assets/pred/5pred.png'),
  require('@/assets/pred/6pred.png'),
  require('@/assets/pred/7pred.png'),
  require('@/assets/pred/8pred.png'),
  require('@/assets/pred/9pred.png'),
  require('@/assets/pred/10pred.png'),
  require('@/assets/pred/11pred.png'),
  require('@/assets/pred/12pred.png'),
  require('@/assets/pred/13pred.png'),
  require('@/assets/pred/14pred.png'),
  require('@/assets/pred/15pred.png')],
      value: "",
      eloptions: [
        {
          label: "算法1",
          value: "1",
        },
        {
          label: "算法2",
          value: "2",
        },
      ],
    };
  },

  mounted() {},

  methods: {
    previousclick(){
      this.$refs.carousel.prev()
    },
    nextclick(){
      this.$refs.carousel.next()
    }
  },
};
</script>

<style scoped>
.heads {
  width: 100%;
  /* height: 400px; */
  background: url("@/assets/bgc4.png");
  background-size: 100% 100%;
  padding: 30px 0;
  box-sizing: border-box;
}
.heads .head-bx {
  width: 700px;
  margin: 0 auto;
}
.heads .head-bx .top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
}
.heads .head-bx .top .left {
  width: 40%;
  display: flex;
  align-items: center;
  /* color: #f6f6f6; */
}
.heads .head-bx .top .left p {
  margin-right: 10px;
}
.heads .head-bx .top .right {
  width: 55%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.btn {
  min-width: 100px;
  height: 40px;
  display: inline-block;
  padding: 10px 20px;
  color: #fff;
  font-size: 1rem;
  background-color: #2d5b99;
  box-sizing: border-box;
  cursor: pointer;
}
.pczhn {
  width: 100%;
  height: 500px;
  width: 100%;
  background-color: #fff;
  margin-top: 20px;
}
.pczhn img{
  display: block; /* 防止图片下方出现空白间隙 */
  max-width: 100%; /* 确保图片宽度不超过容器宽度 */
  height: auto; /* 自动调整高度以保持原图宽高比 */
  object-fit: cover;
}
:deep .el-carousel{
  height: 100% !important;
}
:deep .el-carousel__container{
  height: 100% !important;
}
</style>